import { jsx } from "react/jsx-runtime";
import { useRef, useEffect } from "react";
import { axisTypography, axisTypographyOld } from "./StackBarChart.css.mjs";
const StackBarChartTick = ({
  axisProps,
  locale,
  onTickRender,
  axisFormatter,
  axis,
  isNVLEnabled
}) => {
  var _a;
  const { x, y, width, height, payload } = axisProps;
  const tickRef = useRef(null);
  const numberFormatter = new Intl.NumberFormat(locale, {
    notation: "compact"
  });
  const axisValue = axisFormatter ? numberFormatter.format(payload.value) : payload.value;
  useEffect(() => {
    if (onTickRender) {
      onTickRender(
        tickRef.current ? Math.ceil(tickRef.current.getBoundingClientRect().width) : 0
      );
    }
  }, [(_a = tickRef == null ? void 0 : tickRef.current) == null ? void 0 : _a.clientWidth, onTickRender]);
  return /* @__PURE__ */ jsx(
    "text",
    {
      x,
      y,
      width,
      height,
      orientation: "left",
      stroke: "none",
      className: `recharts-text recharts-cartesian-axis-tick-value ${isNVLEnabled ? axisTypography : axisTypographyOld}`,
      textAnchor: axis === "x" ? "middle" : "end",
      ref: tickRef,
      children: /* @__PURE__ */ jsx("tspan", { x, dy: axis === "x" ? "12px" : "3px", children: axisValue })
    }
  );
};
export {
  StackBarChartTick
};
